<template>
  <PopUpModal ref="popup">
    <div class="m-3 bb-transfer-dialog">
      <div class="row w-50 img-fluid m-auto">
        <img
          :src="image"
          class="img-fluid"
          alt="question mark image"
        />
      </div>
      <div class="row bb-hdg mt-3 mb-1 justify-content-center text-center">
        {{ title }}
      </div>
      <div class="row bb-sub-hdg mt-3 mb-1 justify-content-center text-center">
        {{ message }}
      </div>
      <div
        v-if="subject"
        class="row bb-sub-sub-hdg mt-2 mb-3 justify-content-center text-center"
      >
        {{ subject }}
      </div>
      <div
        v-if="targets.length > 0"
        class="d-grid gap-2 mt-3"
      >
        <button
          v-for="target in targets"
          :key="target.id"
          type="button"
          class="btn btn-lg btn-primary bb-transfer-target"
          @click="_confirm(target)"
        >
          <span class="bb-transfer-target-name">{{ target.name }}</span>
          <span class="bb-transfer-target-player">{{
            target.player_name
          }}</span>
        </button>
      </div>
      <div
        v-else
        class="row bb-sub-sub-hdg mt-3 mb-2 justify-content-center text-center"
      >
        No active recipients available.
      </div>
      <div class="d-grid gap-2 mt-3">
        <button
          type="button"
          class="btn btn-lg btn-warning"
          @click="_cancel"
        >
          {{ cancelButton }}
        </button>
      </div>
    </div>
  </PopUpModal>
</template>

<script>
import PopUpModal from './PopUpModal.vue'
import image from '../assets/images/bbQuestionMark96.png'

export default {
  name: 'TransferRecipientDialog',
  components: {
    PopUpModal,
  },
  data: () => ({
    title: 'Transfer Artefact',
    message: 'Choose Recipient',
    subject: undefined,
    cancelButton: 'Cancel',
    targets: [],
    resolvePromise: undefined,
    image,
  }),
  methods: {
    show(opts = {}) {
      this.title = opts.title || 'Transfer Artefact'
      this.message = opts.message || 'Choose Recipient'
      this.subject = opts.subject
      this.cancelButton = opts.cancelButton || 'Cancel'
      this.targets = Array.isArray(opts.targets) ? opts.targets : []
      this.$refs.popup.open()

      return new Promise((resolve) => {
        this.resolvePromise = resolve
      })
    },
    _confirm(target) {
      this.$refs.popup.close()
      this.resolvePromise?.(target)
    },
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise?.(null)
    },
  },
}
</script>

<style scoped>
.bb-transfer-target {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
}

.bb-transfer-target-name {
  font-weight: 400;
}

.bb-transfer-target-player {
  font-size: 1.1rem;
  opacity: 0.8;
}
</style>
